// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__29x3N","dragIcon":"Choice_dragIcon__3pNlL","left":"Choice_left__2Ln0v","input":"Choice_input__2nPDE"};